import {Component, OnInit, OnDestroy} from '@angular/core';
import * as _ from 'lodash';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-faq-page',
  templateUrl: './faq-page.component.html',
  styleUrls: ['./faq-page.component.scss']
})
export class FaqPageComponent implements OnInit, OnDestroy {

  faqQuestions: any[];
  subjects: any;
  private langSub: Subscription;

  constructor(private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.buildFaq();
    this.langSub = this.translate.onLangChange.subscribe(() => this.buildFaq());
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }

  private buildFaq(): void {
    this.faqQuestions = [
      {
        cat: this.translate.instant('FAQ.CAT_PERSONAL_IMPORT'),
        q: this.translate.instant('FAQ.Q1'),
        a: this.translate.instant('FAQ.A1')
      },
      {
        cat: this.translate.instant('FAQ.CAT_PERSONAL_IMPORT'),
        q: this.translate.instant('FAQ.Q2'),
        a: this.translate.instant('FAQ.A2')
      },
      {
        cat: this.translate.instant('FAQ.CAT_DEALERS'),
        q: this.translate.instant('FAQ.Q3'),
        a: this.translate.instant('FAQ.A3')
      },
      {
        cat: this.translate.instant('FAQ.CAT_DEALERS'),
        q: this.translate.instant('FAQ.Q4'),
        a: this.translate.instant('FAQ.A4')
      },
      {
        cat: this.translate.instant('FAQ.CAT_DEALERS'),
        q: this.translate.instant('FAQ.Q5'),
        a: this.translate.instant('FAQ.A5')
      }
    ];

    this.subjects = _.groupBy(this.faqQuestions, 'cat');
    this.subjects[this.translate.instant('FAQ.CAT_ALL')] = this.faqQuestions;
  }
}
